import { useState, useCallback, ReactNode } from 'react';
import { LoadingContext } from '@/contexts/LoadingContext';
import Spinner from './Spinner';

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>
      {children}
      {isLoading && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
    </LoadingContext.Provider>
  );
};

export { LoadingContext };
